import * as React from 'react';

import * as _ from 'underscore';
const compareObjects = require('fast-deep-equal');

declare var require: any;

import NumberField from './NumberField';

export class SizeField extends React.Component<any, any> {
    constructor(props) {
        super(props);

        //  this.props.options.isInteger: true

        this.state = {
            value: this.props.value
        };
    }

    get_isInteger(): boolean {
        let isInteger = true; // default
        if (this.props.options != null && this.props.options.isInteger != null) {
            isInteger = this.props.options.isInteger;
        }
        return isInteger;
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        const newValue = nextProps.value;

        if (!compareObjects(newValue, this.state.value)) {
            this.setState({ value: newValue });
        }
    }

    handleValueChange(value) {
        //this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    changeHeight = (newHeight) => {
        let obj = _.clone(this.props.value || {});
        obj.height = newHeight;
        this.handleValueChange(obj);
    };

    changeWidth = (newWidth) => {
        let obj = _.clone(this.props.value || {});
        obj.width = newWidth;
        this.handleValueChange(obj);
    };

    render() {
        //  or this.props.value
        //let displayVal_height = this.state.value.height || 0;  // or null ?
        //let displayVal_width = this.state.value.width || 0;
        let displayVal_height = this.state.value.height || null; // ?
        let displayVal_width = this.state.value.width || null;

        let isInteger = this.get_isInteger();

        //  glob={ this.props.glob }
        return (
            <div className="size-field">
                <div className={'height'}>
                    <label>Width</label>
                    <br />
                    <NumberField
                        value={displayVal_width}
                        allowNull={true}
                        integer={isInteger}
                        positive={true}
                        onChange={this.changeWidth}
                    />
                </div>
                <div className={'height'}>
                    <label>Height</label>
                    <br />
                    <NumberField
                        value={displayVal_height}
                        allowNull={true}
                        integer={isInteger}
                        positive={true}
                        onChange={this.changeHeight}
                    />
                </div>
            </div>
        );
    }
}
